
<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.detail-row {
  display: flex;
  padding: 0 20px;
}
.detail-row .item {
  display: flex;
  flex: 1;
  align-items: center;
}
.detail-row .item .tittle {
  width: 110px;
  text-align: left;
}
.detail-row .item .content {
  width: 500px;
  text-align: left;
}
.detail-row .pdf-container img {
  width: 40px;
  height: 40px;
}
.detail-row .item .pdf-container {
  width: auto;
  text-align: center;
}
/deep/ .el-upload-list {
    text-align: left;
    max-height: 150px;
    overflow-y: auto;
}
</style>
<style >
.freelist .el-form-item__content {
  margin-left: 0 !important;
}
.freelist .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.freelist .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.freelist .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.freelist .el-image {
  visibility: hidden;
}
.freelist .file1 .el-upload--picture-card {
  display: none;
}
.el-image-viewer__wrapper {
  z-index: 99999 !important;
}
.el-col-8{
  display: flex;
}
.ipt-sty{
  flex: 1;
}
</style>
<template>
  <div class="content freelist">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">公司名称：</div>
           <el-select v-model="page.tenantGuid" placeholder="请选择公司名称" filterable class="ipt-sty" @change="getOrganisationList(page.tenantGuid)">
             <el-option 
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col> 
        <el-col :span="8">
          <div class="search-area-div">部门名称：</div>
          <el-select v-model="page.organisation" placeholder="请选择部门名称" filterable class="ipt-sty" @focus="getOrganisation()">
            <el-option v-for="item in organisationList" :key="item.guid" :label="item.organisationName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div">上传时间：</div>
          <el-date-picker
            v-model="timeLists"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
             class="ipt-sty"
            end-placeholder="结束时间">
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15">
        <el-col :span="8">
          <div class="search-area-div">人员/手机号：</div>
          <el-input v-model="page.staffNameMobileNo" class="ipt-sty" placeholder="请输入人员/手机号"></el-input>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div">支付月份：</div>
          <el-date-picker
            class="ipt-sty"
            v-model="page.accountMonth"
            type="month"
            align="left"
            unlink-panels
            placeholder="请选择支付月份"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyyMM"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="8" style="display:block" class="t-right">
          <el-button size="medium" type="info" @click="getList(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="addContract()">上传完税凭证</el-button>
      <el-button icon="el-icon-plus" size="medium" type="info" @click="addContractMore()">批量上传完税凭证</el-button>
      <!-- <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> -->
    </div>
    <div class="back-color-fff p16">
      <el-table :data="tableData" border style="width: 100%;" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column prop="accountMonth" width="110" label="支付月份" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.accountMonth }}</template>
        </el-table-column>

        <el-table-column prop="tenantName" label="公司名称" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>

        <el-table-column prop="organisationName" label="部门名称" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.organisationName | roleNames}}</template>
        </el-table-column>
 
        <el-table-column prop="staffName" width="130" label="人员姓名" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.staffName}}</template>
        </el-table-column>

        <el-table-column prop="mobileNo" width="130" label="人员手机号" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.mobileNo }}</template>
        </el-table-column>
        <el-table-column prop="inputTime" width="130" label="上传时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.inputTime | getDate }}</template>
        </el-table-column>
        <!-- <el-table-column prop="pictContent" label="发放凭证" header-align="center" align="center">
          <template slot-scope="scope">
            <a
              v-if="scope.row.pictContent != '[]' && scope.row.pictContent != null"
              class="txt-color"
              style="text-decoration: underline"
              @click="preview(scope.row.pictContent)"
              >已上传,点击查看</a
            >
            <a v-else>待运营上传</a>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" header-align="center" align="center" width="250">
          <template slot-scope="scope">
            <a class="txt-color" @click="preview(scope.row.pictContent)">查看凭证 | </a>
            <a class="txt-color" v-if="scope.row.pictContent != '[]' && scope.row.pictContent != null" @click="down(scope.row)">下载凭证 | </a>  
            <a class="txt-color" @click="editContract(scope.row)">编辑 | </a>
            <a class="txt-color-red" @click="getDeleteData(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>

    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="50%">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">支付月份</span>
          <el-date-picker
            class="ipt-sty fl"
            v-model="tax.accountMonth"
            type="month"
            placeholder="选择支付月份"
            value-format="yyyyMM"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">选择公司</span>
          <el-select v-model="tax.tenantGuid" placeholder="请选择公司" class="ipt-sty fl" filterable @change="getStaffList(tax.tenantGuid)">
             <el-option 
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">选择人员</span>
          <el-select v-model="tax.staffGuid" placeholder="请选择人员" class="ipt-sty fl" filterable  @focus="getStaff()" @change="getStaffDetail(tax.staffGuid)">
             <el-option 
              v-for="item in staffList"
              :key="item.guid"
              :label="item.staffName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="tax.organisationName">
          <span slot="label" style="color: red">*</span>
          <span slot="label">人员信息</span>
          <span class="fl">{{tax.mobileNo}} {{tax.organisationName | roleNames}} {{tax.positionNames | roleNames}}</span>
        </el-form-item>   
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">完税凭证</span>
          <el-upload
            action="#"
            name="image"
            class="fl"
            list-type="picture-card"
            :headers="token"
            :limit="1"
            accept=".jpg,.png,.jpeg"
            :on-exceed="handleExceed"
            :file-list="filePdfAttachListII"
            :on-remove="handlePdfRemoveII"
            :http-request="uploadPdfII"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <div style="color: #999; text-align: left; margin-left: 100px; margin-bottom: 20px">
          说明：上传业务员的相关完税凭证截图
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          v-if="textTitle == '新增完税凭证'"
          @click="addReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button
          size="medium"
          type="info"
          v-else
          @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="批量上传完税凭证" :visible.sync="dialogVisible1" width="50%">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">支付月份</span>
          <el-date-picker
            class="ipt-sty fl"
            v-model="tax1.accountMonth"
            type="month"
            placeholder="选择支付月份"
            value-format="yyyyMM"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">选择公司</span>
          <el-select v-model="tax1.tenantGuid" filterable placeholder="请选择公司" class="ipt-sty fl">
             <el-option 
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">完税凭证</span>
          <el-upload
            class="fl upload-demo"
            drag
            action="#"
            :headers="token"
            accept=".jpg,.png,.jpeg"
            :on-remove="handleImgRemove"
            :http-request="uploadImg"
            show-file-list
            :file-list="filePdfAttachListIII"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </el-form-item>
        <div style="color: #999; text-align: left; margin-left: 100px; margin-bottom: 20px">
          说明：<br>1、选择本地电脑中的一个文件夹;<br>
          　　　2、文件夹中存放每个业务员完税凭证的图片;<br>
          　　　3、必须一人一张图，每张图片的命名规则如：张三_13100000001;
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible1 = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          @click="addReqVersionAll"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button> 
      </span>
    </el-dialog>
    <el-dialog
      title="上传错误提示"
      :visible.sync="dialogVisible2"
      width="30%">
      <div v-for="er in errorInfoList">
        <span>{{er}}</span>
      </div> 
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-image :src="srcList?srcList[0]:''" ref="preview" :preview-src-list="srcList"></el-image> -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false;
        }
      "
      :url-list="srcLists"
    />
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  data() {
    return {
      giveStatueList: [
        { value: '0', label: '全部' },
        { value: '1', label: '已上传' },
        { value: '2', label: '未上传' },
      ],
      tax: {
        tenantGuid: '',
        accountMonth: '',
        pictContent: '',
        staffName: '',
        staffGuid: '',
        mobileNo: '',
        organisationGuid: '',
        organisationName: '',
        inputTime: '',
        positionNames:''
      },
      tax1: {
        tenantGuid: '',
        accountMonth: '',
        pictContent: '',
        staffName: '',
        staffGuid: '',
        mobileNo: '',
        organisationGuid: '',
        organisationName: '',
        inputTime: '',
        positionNames:''
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        startTime: '',
        endTime: '',
        tenantGuid: '',
        organisation:'',
        accountMonth:'',
        staffGuid:'',
        staffNameMobileNo:'',
        operationTenantGuid:''
      },
      staffList:[],
      tenantList: [],
      organisationList:[],
      errorInfoList:[],
      timeLists:'',
      srcLists:[],

      
      taskGuid: [],
      srcList: [],
      fullscreenLoading: false,
      textTitle: '新增完税凭证',
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      startEndTime: '',
      payMonth: '',
      payMoney: '',
      note: '',
      payFile: '',

      guid: '',
      tableLoading: false,
      tableData: [],
      height: window.innerHeight - 400,
      right: 'right',

      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      filePdfAttachList: [],
      filePdfAttachListII: [],
      filePdfAttachListIII:[],
      showViewer: false,
      taskList: [],
      taskGroup: [],
      currentCompanyGuid:''
    };
  },
  created() {
    // this.page.giveStatue = this.$route.query.giveStatue; 
    this.getTenantList(); 
    this.getList();
    // this.getTaskList();

  },
  watch: {
    payMonth(newVal) {
      if (!newVal) return;
      var newVal = newVal + '-01';
      var self = this;
      self.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-account-month-full-area?date=` +
            newVal +
            '&tenantGuid=' +
            this.currentCompanyGuid
        )
        .then((resp) => {
          self.startEndTime = resp.data.data.replace(',', '至');
        });
    }
  },
  methods: {
    getTaskList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        payState: '未结算',
        isService: 'Y'
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data.records) {
            self.taskList = res.data.data.records.concat(this.taskGroup);
          } else {
            self.taskList = this.taskGroup;
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    preview(srcList) {
      this.srcLists = [];
      // var srcList = JSON.parse(srcList);
      srcList.forEach((item) => {
        this.srcLists.push(item.path);
      });
      this.$forceUpdate();
      this.showViewer = true;
      // setTimeout(()=>{
      //   this.$refs.preview.clickHandler()
      // },300)
    },
    getTenantList() {
      let self = this;
      let query = {
        isService:true,
        tenantGuid:localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
          // self.page.tenantGuid = self.tenantList[0].sendTenantGuid;
          // self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getOrganisationList(tenantGuid) {
      let self = this;
      let query = {
        pageIndex:1,
        pageSize:-1,
        tenantGuid:tenantGuid
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getOrganisation(){
      if(this.page.tenantGuid == '' || this.page.tenantGuid == null){
        this.$message.error('请选择公司!');
        return
      }
    },
    getStaff(){
      if(this.tax.tenantGuid == '' || this.tax.tenantGuid == null){
        this.$message.error('请选择公司!');
        return
      }
    },
    getStaffList(guid) {
      let self = this;
      let query = {
        pageIndex:1,
        pageSize:-1,
        tenantGuid:guid
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.staffList = res.data.data.records;
          // self.tax.staffGuid = self.staffList[0].guid;
          // self.tax.staffName = self.staffList[0].staffName;
          // if(self.staffList[0].organisationNames != null){
          //   self.tax.organisationGuid = self.staffList[0].organisationGuids;
          //   self.tax.organisationName = self.staffList[0].organisationNames;
          //   }
          // if(self.staffList[0].positionNames != null){
          //   self.tax.positionNames = self.staffList[0].positionNames;
          //   }
          // self.tax.mobileNo = self.staffList[0].mobileNo;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getStaffDetail(guid){
      let self = this;
      if(self.staffList != null && self.staffList.length > 0){
        self.staffList.forEach((i)=>{
          if(guid == i.guid){
            self.tax.staffName = i.staffName;
            if(i.organisationNames != null ){
                self.tax.organisationGuid = i.organisationGuids;
                self.tax.organisationName = i.organisationNames;
              }
            if(i.positionNames != null ){
                self.tax.positionNames = i.positionNames;
              }
            self.tax.mobileNo = i.mobileNo;
          }
        })
      }
    },
    emptySearch() {
      this.timeLists = [];
      this.organisationList = [];
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        startTime: '',
        endTime: '',
        tenantGuid: '',
        organisation:'',
        accountMonth:'',
        staffGuid:'',
        staffNameMobileNo:''
      };

      // this.page.tenantGuid = this.tenantList[0].sendTenantGuid;
      this.getList(true);
    },
    addContract() {
      this.textTitle = '新增完税凭证';
      this.tax = {
        tenantGuid: '',
        accountMonth: '',
        pictContent: '',
        staffName: '',
        staffGuid: '',
        mobileNo: '',
        organisationGuid: '',
        organisationName: '',
        inputTime: '',
        positionNames:''
      };
      this.staffList = [];
      this.filePdfAttachListII = [];
      this.dialogVisible = true;
    },
    addContractMore(){
      this.tax1 = {
        tenantGuid: '',
        accountMonth: '',
        pictContent: '',
        staffName: '',
        staffGuid: '',
        mobileNo: '',
        organisationGuid: '',
        organisationName: '',
        inputTime: '',
        positionNames:''
      };
      this.filePdfAttachListIII = [];
      this.dialogVisible1 = true;
    },
    editContract(detail) {
      this.textTitle = '编辑完税凭证';
      this.filePdfAttachListII = [];
      this.getStaffList(detail.tenantGuid);
      this.tax = {
        guid:detail.guid,
        tenantGuid:detail.tenantGuid,
        accountMonth:detail.accountMonth,
        pictContent:detail.pictContent,
        staffName:detail.staffName,
        staffGuid:detail.staffGuid,
        mobileNo:detail.mobileNo,
        organisationGuid:detail.organisationGuid,
        organisationName:detail.organisationName,
        inputTime:detail.inputTime,
        positionNames:detail.positionName,
      };
      if(detail.pictContent != null && detail.pictContent.length > 0){
        detail.pictContent.forEach((item) => {
          this.filePdfAttachListII.push({
            name: item.fileName,
            url: item.path,
          });
        });
      } 
      this.dialogVisible = true;
    },
    down(detail){
      let path = '';
      let name = '';
      if(detail.pictContent != null && detail.pictContent.length > 0){
        detail.pictContent.forEach((item) => {
          path = item.path;
          name = item.fileName;
        });
        this.downloadIamge(path,name);
      } 
    },
    downloadIamge(imgsrc, name) {//下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
      
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    getList(flg) {
      var self = this;
      if(flg){
        self.page.pageIndex = 1;
      } 
      self.page.operationTenantGuid = self.$store.state.guid;
      if(self.timeLists != null && self.timeLists.length > 0){
        self.page.startTime = self.$moment(self.timeLists[0]).format('YYYY-MM-DD HH:mm:ss');
        self.page.endTime = self.$moment(self.timeLists[1]).format('YYYY-MM-DD 23:59:59');
      }else{
        self.page.startTime = '';
        self.page.endTime = '';
      }
      self.tableLoading = true;
      self.api.get(`/${serverConfig.msUserRemunerationService}/tax-certificate/list?accountMonth=`+ this.page.accountMonth +'&operationTenantGuid='+this.page.operationTenantGuid +'&startTime='+this.page.startTime+'&endTime='+this.page.endTime+'&organisation='+this.page.organisation+'&pageIndex='+this.page.pageIndex+'&pageSize='+this.page.pageSize+'&tenantGuid='+this.page.tenantGuid+'&staffNameMobileNo='+this.page.staffNameMobileNo).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getDeleteData(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msUserRemunerationService}/tax-certificate/del`,[guid]).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    addReqVersionAll(){
      var self = this;
      if (!this.tax1.accountMonth) {
        self.$message('请选择结算月份!');
        return;
      }
      if (!this.tax1.tenantGuid) {
        self.$message('请选择公司!');
        return;
      }
      let imgList = [];
      if(this.filePdfAttachListIII != null && this.filePdfAttachListIII.length > 0){
        this.filePdfAttachListIII.forEach((i)=>{
          let item = {
            fileName:i.name,
            path:i.url
          }
          imgList.push(item);
        })
      }
      console.log(imgList);
      var tenantList = this.tenantList; 
      var req = {
        tenantGuid: self.tax1.tenantGuid, 
        accountMonth: this.tax1.accountMonth,
        pictContent: imgList
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msUserRemunerationService}/tax-certificate/batch-import`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible1 = false;
          self.$message.success('新增成功');
          if(res.data.data.errorInfo != null && res.data.data.errorInfo.length > 0){
            this.errorInfoList = res.data.data.errorInfo;
            this.dialogVisible2 = true;
          }
          self.page.pageIndex = 1;
          self.getList(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    addReqVersion() {
      var self = this;
      if (!this.tax.accountMonth) {
        self.$message('请选择结算月份!');
        return;
      }
      if (!this.tax.tenantGuid) {
        self.$message('请选择公司!');
        return;
      }
      if (!this.tax.staffGuid) {
        self.$message('请选择人员!');
        return;
      } 
      let imgList = [];
      if(this.filePdfAttachListII != null && this.filePdfAttachListII.length > 0){
        let item = {
          fileName:this.filePdfAttachListII[0].name,
          path:this.filePdfAttachListII[0].url
        }
        imgList.push(item);
      }
      console.log(imgList);
      var tenantList = this.tenantList; 
      var req = {
        tenantGuid: self.tax.tenantGuid, 
        accountMonth: this.tax.accountMonth,
        staffGuid:this.tax.staffGuid,
        staffName: this.tax.staffName,
        organisationGuid: this.tax.organisationGuid,
        organisationName: this.tax.organisationName,
        mobileNo: this.tax.mobileNo,
        pictContent: imgList,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msUserRemunerationService}/tax-certificate/add`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion() {
      var self = this;
      if (!this.tax.accountMonth) {
        self.$message('请选择结算月份!');
        return;
      }
      if (!this.tax.tenantGuid) {
        self.$message('请选择公司!');
        return;
      }
      if (!this.tax.staffGuid) {
        self.$message('请选择人员!');
        return;
      } 
      let imgList = [];
      if(this.filePdfAttachListII != null && this.filePdfAttachListII.length > 0){
        let item = {
          fileName:this.filePdfAttachListII[0].name,
          path:this.filePdfAttachListII[0].url
        }
        imgList.push(item);
      }
      console.log(imgList);
      var tenantList = this.tenantList; 
      var req = {
        guid: self.tax.guid,
        tenantGuid: self.tax.tenantGuid, 
        accountMonth: this.tax.accountMonth,
        staffGuid:this.tax.staffGuid,
        staffName: this.tax.staffName,
        organisationGuid: this.tax.organisationGuid,
        organisationName: this.tax.organisationName,
        mobileNo: this.tax.mobileNo,
        pictContent: imgList,
      };
      self.fullscreenLoading = true;
      self.api.put(`/${serverConfig.msUserRemunerationService}/tax-certificate/update`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('修改成功');
          self.page.pageIndex = 1;
          self.getList(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },

    handleExceed(files, filePdfAttachList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handlePdfRemove(file) {
      let self = this;
      self.filePdfAttachList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.filePdfAttachList.splice(ind, 1);
        }
      });
    },
    uploadPdf(file) {
      let self = this;
      // console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              url: res.data.data,
            };
            self.filePdfAttachList.push(item);
            console.log(self.filePdfAttachList);
            self.$message.success('上传成功');
          } else {
            self.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleImgRemove(file) {
      let self = this;
      self.filePdfAttachListIII.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.filePdfAttachListIII.splice(ind, 1);
        }
      });
    },
    handlePdfRemoveII(file) {
      let self = this;
      self.filePdfAttachListII.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.filePdfAttachListII.splice(ind, 1);
        }
      });
    },
    uploadImg(file) {
      let self = this;
      // console.log('sssssssssssssssssssssssssss',file.file.name);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              url: res.data.data,
            };
            self.filePdfAttachListIII.push(item);
            // self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    uploadPdfII(file) {
      let self = this;
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              url: res.data.data,
            };
            self.filePdfAttachListII.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handlePictureCardPreview(item) {
      this.srcList = [];
      this.srcList.push(item.url);
      this.$forceUpdate();
      setTimeout(() => {
        this.$refs.preview.clickHandler();
      }, 300);
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.search-area-div{
  width: 110px;
}
.el-date-editor .el-range__icon{
  margin-left: 0px;
}
</style>